"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConsentForAllCategories = void 0;
const constants_1 = require("./constants");
const js_cookie_1 = __importDefault(require("js-cookie"));
const CookieCategory_1 = require("./CookieCategory");
const hasCategoryConsent_1 = require("./helpers/hasCategoryConsent");
/**
 * Get all cookie category consents
 * @param isOneTrustEnabled boolean - whether oneTrust is enabled
 * @returns Record<CookieCategory, boolean> - a record of all cookie categories and whether consent has been given for them
 */
const getConsentForAllCategories = () => {
    // No need to verify consent of category from cookie if oneTrust is not enabled
    if (typeof window !== 'undefined' && !window[constants_1.ONETRUST_ENABLED]) {
        return {
            [CookieCategory_1.CookieCategory.StrictlyNecessary]: true,
            [CookieCategory_1.CookieCategory.Performance]: true,
            [CookieCategory_1.CookieCategory.Functional]: true,
            [CookieCategory_1.CookieCategory.Targeting]: true
        };
    }
    const optanonConsent = js_cookie_1.default.get(constants_1.CONSENT_COOKIE) || '';
    return {
        [CookieCategory_1.CookieCategory.StrictlyNecessary]: (0, hasCategoryConsent_1.hasCategoryConsent)(optanonConsent, CookieCategory_1.CookieCategory.StrictlyNecessary),
        [CookieCategory_1.CookieCategory.Performance]: (0, hasCategoryConsent_1.hasCategoryConsent)(optanonConsent, CookieCategory_1.CookieCategory.Performance),
        [CookieCategory_1.CookieCategory.Functional]: (0, hasCategoryConsent_1.hasCategoryConsent)(optanonConsent, CookieCategory_1.CookieCategory.Functional),
        [CookieCategory_1.CookieCategory.Targeting]: (0, hasCategoryConsent_1.hasCategoryConsent)(optanonConsent, CookieCategory_1.CookieCategory.Targeting)
    };
};
exports.getConsentForAllCategories = getConsentForAllCategories;
